module.exports = __webpack_public_path__ + "static/anand.ef07aac1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anand.jpeg
// module id = 456
// module chunks = 35783957827783